(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Templates"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getVariantId(row) {
      const select = row.querySelector('[data-stl-variant]');
      if (select) return select.value;
      const btn = row.querySelector('[data-stl-add-single]');
      return btn ? btn.dataset.variantId : null;
    }

    function cartSectionIds() {
      const ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        if (el.dataset && el.dataset.sectionId) ids.push(el.dataset.sectionId);
      });
      return ids;
    }

    async function addItems(items, sourceEl) {
      const addUrl =
        (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
      const payload = {
        items: items.map(function (i) {
          return { id: Number(i.id), quantity: i.quantity };
        }),
        sections: cartSectionIds().join(','),
      };
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data && data.status) {
        throw new Error(data.description || data.message || 'Add to cart failed');
      }

      let cart = null;
      try {
        cart = await (await fetch('/cart.js')).json();
      } catch (e) {
        cart = null;
      }

      sourceEl.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart || undefined,
            sourceId: sourceEl.id || 'shop-the-look',
            data: {
              source: 'shop-the-look',
              sections: data && data.sections ? data.sections : undefined,
              itemCount: cart ? cart.item_count : undefined,
            },
          },
        })
      );
      return data;
    }

    function setLoading(button, loading) {
      if (!button) return;
      button.classList.toggle('is-loading', loading);
      button.disabled = loading;
    }

    function setActive(section, index) {
      section.querySelectorAll('[data-stl-dot]').forEach(function (dot) {
        dot.classList.toggle('is-active', dot.dataset.index === index);
      });
      section.querySelectorAll('[data-stl-row]').forEach(function (row) {
        row.classList.toggle('is-active', row.dataset.index === index);
      });
    }

    document.addEventListener('change', function (event) {
      const select = event.target.closest('[data-stl-variant]');
      if (!select) return;
      const row = select.closest('[data-stl-row]');
      if (!row) return;
      const option = select.options[select.selectedIndex];
      const priceEl = row.querySelector('[data-stl-price]');
      if (priceEl && option && option.dataset.price) {
        priceEl.textContent = option.dataset.price;
      }
      const btn = row.querySelector('[data-stl-add-single]');
      if (btn) btn.dataset.variantId = select.value;
    });

    document.addEventListener('click', async function (event) {
      const dot = event.target.closest('[data-stl-dot]');
      if (dot) {
        const section = dot.closest('[data-shop-the-look]');
        const index = dot.dataset.index;
        setActive(section, index);
        const row = section.querySelector('[data-stl-row][data-index="' + index + '"]');
        if (row) row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }

      const single = event.target.closest('[data-stl-add-single]');
      if (single && !single.disabled) {
        const row = single.closest('[data-stl-row]');
        const variantId = getVariantId(row);
        if (!variantId) return;
        setLoading(single, true);
        try {
          await addItems([{ id: variantId, quantity: 1 }], single);
        } catch (error) {
          console.error(error);
        } finally {
          setLoading(single, false);
        }
        return;
      }

      const addAll = event.target.closest('[data-stl-add-all]');
      if (addAll && !addAll.disabled) {
        const section = addAll.closest('[data-shop-the-look]');
        const items = [];
        section.querySelectorAll('[data-stl-row]').forEach(function (row) {
          const btn = row.querySelector('[data-stl-add-single]');
          if (btn && btn.disabled) return;
          const variantId = getVariantId(row);
          if (variantId) items.push({ id: variantId, quantity: 1 });
        });
        if (!items.length) return;
        setLoading(addAll, true);
        try {
          await addItems(items, addAll);
        } catch (error) {
          console.error(error);
        } finally {
          setLoading(addAll, false);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fancy-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var DESKTOP_QUERY = window.matchMedia('(min-width: 801px)');
    var cleanups = [];
    var pointer = {
      x: 0,
      y: 0,
      t: 0,
      px: 0,
      py: 0,
      pt: 0,
      vx: 0,
      vy: 0,
      ax: 0,
      ay: 0,
      ready: false,
      history: []
    };

    function clamp(v, min, max) {
      return Math.max(min, Math.min(max, v));
    }

    function loadGsap() {
      if (window.gsap) {
        return Promise.resolve(window.gsap);
      }

      if (window.__fancyGsapPromise) {
        return window.__fancyGsapPromise;
      }

      window.__fancyGsapPromise = new Promise(function(resolve, reject) {
        var script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
        script.async = true;
        script.onload = function() {
          resolve(window.gsap || null);
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return window.__fancyGsapPromise;
    }

    document.addEventListener('pointermove', function(event) {
      var now = performance.now();
      pointer.px = pointer.x;
      pointer.py = pointer.y;
      pointer.pt = pointer.t;
      pointer.x = event.clientX;
      pointer.y = event.clientY;
      pointer.t = now;
      if (pointer.ready) {
        var dt = Math.max(1, pointer.t - pointer.pt);
        var nextVx = (pointer.x - pointer.px) / dt;
        var nextVy = (pointer.y - pointer.py) / dt;
        pointer.ax = (nextVx - pointer.vx) / dt;
        pointer.ay = (nextVy - pointer.vy) / dt;
        pointer.vx = nextVx;
        pointer.vy = nextVy;
      }
      pointer.history.push({vx: pointer.vx, vy: pointer.vy, ax: pointer.ax, ay: pointer.ay});
      if (pointer.history.length > 10) 
        pointer.history.shift();
      

      pointer.ready = true;
    }, {passive: true});

    function setup(root) {
      if (root.__fancyBound) {
        return null;
      }

      var medias = Array.prototype.slice.call(root.querySelectorAll('[data-fancy-media]'));
      var mainWrap = root.querySelector('.fancy-main-image-wrap');
      var desktopTexts = Array.prototype.slice.call(root.querySelectorAll('.fancy-hero__desktop-richtext'));
      var ctaWrap = root.querySelector('.fancy-hero__cta-wrap');
      if (medias.length === 0) {
        return null;
      }

      root.__fancyBound = true;


      var state = medias.map(function() {
        return {
          x: 0,
          y: 0,
          vx: 0,
          vy: 0,
          rot: 0,
          vr: 0
        };
      });
      var cycleTimers = [];
      var rafId = 0;
      var lastFrame = performance.now();
      var introActive = false;
      var introTimeline = null;

      function setIntroState(active, hidden) {
        introActive = active;
        root.setAttribute(
          'data-intro-active',
          active
            ? 'true'
            : 'false'
        );
        root.setAttribute(
          'data-intro-state',
          hidden
            ? 'hidden'
            : 'shown'
        );
      }

      function applyStyles() {
        medias.forEach(function(media, index) {
          media.style.setProperty('--move-x', state[index].x.toFixed(2) + 'px');
          media.style.setProperty('--move-y', state[index].y.toFixed(2) + 'px');
          media.style.setProperty('--rot', state[index].rot.toFixed(2) + 'deg');
        });
      }

      function resetPhysics() {
        state.forEach(function(item) {
          item.x = 0;
          item.y = 0;
          item.vx = 0;
          item.vy = 0;
          item.rot = 0;
          item.vr = 0;
        });
        applyStyles();
      }

      function clearCycleTimers() {
        cycleTimers.forEach(function(timer) {
          window.clearTimeout(timer);
        });
        cycleTimers = [];
      }

      function getCornerFrames(media) {
        var frames = [
          media.getAttribute('data-img-1') || '',
          media.getAttribute('data-img-2') || '',
          media.getAttribute('data-img-3') || ''
        ].filter(function(src) {
          return src && src.length > 0;
        });
        return frames.filter(function(src, idx) {
          return frames.indexOf(src) === idx;
        });
      }

      function preloadImage(src, done) {
        if (! src) {
          done();
          return;
        }
        var pre = new Image();
        pre.onload = function() {
          done();
        };
        pre.onerror = function() {
          done();
        };
        pre.src = src;
      }

      function scheduleCornerCycle(gsap, media) {
        var frames = getCornerFrames(media);
        if (frames.length < 2) return;
        

        var cycleMinMs = parseInt(root.getAttribute('data-corner-cycle-min-ms') || '4500', 10);
        var cycleExtraMs = parseInt(root.getAttribute('data-corner-cycle-random-extra-ms') || '5500', 10);
        if (Number.isNaN(cycleMinMs) || cycleMinMs < 0) 
          cycleMinMs = 4500;
        
        if (Number.isNaN(cycleExtraMs) || cycleExtraMs < 0) 
          cycleExtraMs = 5500;
        

        var swapDur = parseFloat(root.getAttribute('data-corner-swap-duration') || '0.7');
        if (Number.isNaN(swapDur) || swapDur < 0.2) 
          swapDur = 0.7;
        
        if (swapDur > 1.5) 
          swapDur = 1.5;
        

        var delay = Math.round(cycleMinMs + Math.random() * cycleExtraMs);
        var timer = window.setTimeout(function() {
          if (! DESKTOP_QUERY.matches || introActive) {
            scheduleCornerCycle(gsap, media);
            return;
          }

          var shell = media.querySelector('.fancy-icon-scale-shell');
          var img = media.querySelector('.fancy-icon-image');
          if (! shell || ! img) {
            scheduleCornerCycle(gsap, media);
            return;
          }

          var current = parseInt(media.getAttribute('data-cycle-index') || '0', 10);
          if (Number.isNaN(current)) 
            current = 0;
          

          var next = (current + 1) % frames.length;

          preloadImage(frames[next], function() {
            gsap.to(shell, {
              scale: 0,
              duration: swapDur,
              ease: 'power3.out',
              transformOrigin: '50% 50%',
              onComplete: function() {
                img.src = frames[next];
                media.setAttribute('data-cycle-index', String(next));
                gsap.to(shell, {
                  scale: 1,
                  duration: swapDur,
                  ease: 'power3.out',
                  onComplete: function() {
                    scheduleCornerCycle(gsap, media);
                  }
                });
              }
            });
          });
        }, delay);
        cycleTimers.push(timer);
      }

      function startCornerCyclers(gsap) {
        clearCycleTimers();
        medias.forEach(function(media) {
          var shell = media.querySelector('.fancy-icon-scale-shell');
          if (shell) 
            gsap.set(shell, {
              scale: 1,
              transformOrigin: '50% 50%'
            });
          

          media.setAttribute('data-cycle-index', '0');
          scheduleCornerCycle(gsap, media);
        });
      }

      function frame(now) {
        var dt = clamp((now - lastFrame) / 16.67, 0.2, 3);
        lastFrame = now;
        var active = false;

        state.forEach(function(item) {
          item.vx += - item.x * 0.034 * dt;
          item.vy += - item.y * 0.034 * dt;
          item.vr += - item.rot * 0.055 * dt;
          item.vx *= Math.pow(0.94, dt);
          item.vy *= Math.pow(0.94, dt);
          item.vr *= Math.pow(0.92, dt);
          item.x += item.vx * dt;
          item.y += item.vy * dt;
          item.rot += item.vr * dt;

          var vel = Math.hypot(item.vx, item.vy);
          if (vel > 0.001) {
            var softDrag = clamp(1 - vel * 0.0025, 0.9, 1);
            item.vx *= softDrag;
            item.vy *= softDrag;
          }
          if ((item.x > 0 && item.vx > 0) || (item.x < 0 && item.vx < 0)) 
            item.vx *= 0.86;
          

          if ((item.y > 0 && item.vy > 0) || (item.y < 0 && item.vy < 0)) 
            item.vy *= 0.86;
          


          if (Math.abs(item.x) > 0.05 || Math.abs(item.y) > 0.05 || Math.abs(item.vx) > 0.01 || Math.abs(item.vy) > 0.01 || Math.abs(item.rot) > 0.02) 
            active = true;
          

        });

        applyStyles();
        if (active) 
          rafId = requestAnimationFrame(frame);
         else 
          rafId = 0;
        

      }

      function kick(event, index) {
        if (! DESKTOP_QUERY.matches || introActive) return;
        

        if (index < 0 || index >= state.length) return;
        


        var now = performance.now();
        var dt = Math.max(8, now - (pointer.pt || now));
        var sample = pointer.history.length
          ? pointer.history[pointer.history.length - 1]
          : null;
        var vx = sample
          ? sample.vx
          : (event.clientX -(pointer.px || event.clientX)) / dt;
        var vy = sample
          ? sample.vy
          : (event.clientY -(pointer.py || event.clientY)) / dt;
        var speed = Math.hypot(vx, vy);
        var accel = sample
          ? Math.hypot(sample.ax, sample.ay)
          : 0;
        var impulse = clamp(Math.max(0, speed - 0.015) * 175 + clamp(accel * 190, 0, 5), 0, 25);
        if (impulse < 0.08) return;
        


        var scaleX = clamp(vx * impulse * 0.65, -28, 28);
        var scaleY = clamp(vy * impulse * 0.65, -28, 28);
        var item = state[index];
        var dirLen = Math.max(0.0001, Math.hypot(vx, vy));
        var nx = vx / dirLen;
        var ny = vy / dirLen;
        var tx = - ny;
        var ty = nx;
        var tangentSign = index % 2 === 0
          ? 1
          : -1;
        var axisAlignment = Math.max(Math.abs(nx), Math.abs(ny));
        var diagonalness = 1 - axisAlignment;
        var rect = medias[index].getBoundingClientRect();
        var cx = rect.left + rect.width * 0.5;
        var cy = rect.top + rect.height * 0.5;
        var ox = event.clientX - cx;
        var oy = event.clientY - cy;
        var offCenterSign = (nx * oy - ny * ox) >= 0
          ? 1
          : -1;
        var radialPower = impulse * (0.68 + index * 0.06);
        var directional = Math.max(- radialPower * 0.08, (scaleX * nx + scaleY * ny) * 0.58);
        var tangent = (scaleX * tx + scaleY * ty) * 0.2 * tangentSign;
        var slightY = tangentSign * radialPower * 0.1;

        item.vx += nx * radialPower + directional * nx + tangent * tx;
        item.vy += ny * radialPower + directional * ny + tangent * ty + slightY;
        item.vr += diagonalness * radialPower * 0.045 * offCenterSign + tangent * 0.03;

        if (! rafId) {
          lastFrame = now;
          rafId = requestAnimationFrame(frame);
        }
      }

      function runIntro(gsap) {
        if (! gsap) {
          root.setAttribute('data-intro-pending', 'false');
          setIntroState(false, false);
          resetPhysics();
          return;
        }
        var isDesktop = DESKTOP_QUERY.matches;
        root.setAttribute('data-intro-pending', 'false');

        setIntroState(true, true);
        resetPhysics();
        if (introTimeline) 
          introTimeline.kill();
        


        if (isDesktop) {
          gsap.set(medias, {
            opacity: 1,
            x: 0,
            y: function(i, el) {
              return root.clientHeight + el.offsetHeight;
            }
          });
        } else {
          gsap.set(medias, {
            opacity: 1,
            '--move-x': '0px',
            '--move-y': function(i, el) {
              return (root.clientHeight + el.offsetHeight) + 'px';
            },
            '--rot': '0deg'
          });
        }
        if (mainWrap) 
          gsap.set(mainWrap, {
            scale: 0,
            opacity: 0,
            transformOrigin: '50% 50%'
          });
        

        if (isDesktop && desktopTexts.length) {
          gsap.set(desktopTexts, {
            autoAlpha: 0,
            x: function(i, el) {
              return el.classList.contains('fancy-hero__desktop-richtext--left')
                ? -window.innerWidth
                : window.innerWidth;
            }
          });
        }
        if (ctaWrap) 
          gsap.set(ctaWrap, {
            autoAlpha: 0,
            y: root.clientHeight * 0.45
          });
        


        introTimeline = gsap.timeline({
          defaults: {
            ease: 'power3.out'
          },
          onComplete: function() {
            if (isDesktop) {
              gsap.set(medias, {clearProps: 'transform,opacity'});
            } else {
              gsap.set(medias, {clearProps: 'opacity'});
            }
            if (mainWrap) 
              gsap.set(mainWrap, {clearProps: 'transform,opacity'});
            

            if (desktopTexts.length) 
              gsap.set(desktopTexts, {clearProps: 'opacity,visibility,transform'});
            

            if (ctaWrap) 
              gsap.set(ctaWrap, {clearProps: 'opacity,visibility,transform'});
            

            setIntroState(false, false);
            resetPhysics();
            if (isDesktop) {
              startCornerCyclers(gsap);
            }
          }
        });

        if (isDesktop) {
          introTimeline.fromTo(medias, {
            x: 0,
            y: function(i, el) {
              return root.clientHeight + el.offsetHeight;
            }
          }, {
            x: 0,
            y: 0,
            duration: 0.65,
            stagger: 0.12
          });

          introTimeline.to(medias, {
            x: function(i, el) {
              var px = parseFloat(el.getAttribute('data-final-x') || '0');
              return px / 100 * (el.offsetWidth || 0);
            },
            y: function(i, el) {
              var py = parseFloat(el.getAttribute('data-final-y') || '0');
              return py / 100 * (el.offsetHeight || 0);
            },
            duration: 0.72
          }, '>');
        } else {
          // Mobile: animate move vars so CSS base shifts stay active during intro.
          introTimeline.to(medias, {
            '--move-x': '0px',
            '--move-y': '0px',
            duration: 0.78,
            stagger: 0.1
          });
        }

        if (mainWrap) 
          introTimeline.to(mainWrap, {
            scale: 1,
            opacity: 1,
            duration: 0.72
          }, '<');
        

        if (isDesktop && desktopTexts.length) {
          introTimeline.to(desktopTexts, {
            x: 0,
            autoAlpha: 1,
            duration: 0.45,
            ease: 'power3.out'
          }, '>');
        }
        if (ctaWrap) {
          introTimeline.to(ctaWrap, {
            y: 0,
            autoAlpha: 1,
            duration: 0.45,
            ease: 'power3.out'
          }, '<');
        }
      }

      var mediaHandlers = medias.map(function(media, index) {
        var handler = function(event) {
          kick(event, index);
        };
        media.addEventListener('mouseenter', handler);
        return handler;
      });

      function onViewportChange() {
        clearCycleTimers();
        loadGsap().then(runIntro).catch(function() {
          root.setAttribute('data-intro-pending', 'false');
          setIntroState(false, false);
          resetPhysics();
          desktopTexts.forEach(function(node) {
            node.style.opacity = '';
            node.style.visibility = '';
            node.style.transform = '';
          });
          if (ctaWrap) {
            ctaWrap.style.opacity = '';
            ctaWrap.style.visibility = '';
            ctaWrap.style.transform = '';
          }
          if (mainWrap) {
            mainWrap.style.opacity = '';
            mainWrap.style.transform = '';
          }
          medias.forEach(function(media) {
            media.style.opacity = '';
            media.style.transform = '';
          });
        });
      }

      if (DESKTOP_QUERY.addEventListener) 
        DESKTOP_QUERY.addEventListener('change', onViewportChange);
       else 
        DESKTOP_QUERY.addListener(onViewportChange);
       onViewportChange();

      return function cleanup() {
        root.__fancyBound = false;
        clearCycleTimers();
        mediaHandlers.forEach(function(handler, index) {
          medias[index].removeEventListener('mouseenter', handler);
        });
        if (DESKTOP_QUERY.removeEventListener) 
          DESKTOP_QUERY.removeEventListener('change', onViewportChange);
         else 
          DESKTOP_QUERY.removeListener(onViewportChange);
        

        if (introTimeline) 
          introTimeline.kill();
        

        if (rafId) 
          cancelAnimationFrame(rafId);
        

      };
    }

    function init(scope) {
      var roots = (scope || document).querySelectorAll('[data-fancy-hero-root]');
      roots.forEach(function(root) {
        var cleanup = setup(root);
        if (cleanup) 
          cleanups.push(cleanup);
        

      });
    }

    init(document);
    document.addEventListener('shopify:section:load', function(event) {
      init(event.target);
    });
    document.addEventListener('shopify:section:unload', function() {
      cleanups.forEach(function(cleanup) {
        cleanup();
      });
      cleanups = [];
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
  function syncMuteUi(ui, video) {
  const muted = video.muted;
  const btn = ui.querySelector('[data-hero-video-mute]');
  const on = ui.querySelector('.hero__video-control-icon--volume-on');
  const off = ui.querySelector('.hero__video-control-icon--volume-off');
  if (!btn || !on || !off) return;
    btn.setAttribute('aria-pressed', muted ? 'true' : 'false');
    btn.setAttribute('aria-label', muted ? ui.dataset.labelUnmute : ui.dataset.labelMute);
    on.hidden = muted;
    off.hidden = !muted;
    }

    function syncPlayUi(ui, video) {
    const paused = video.paused;
    const btn = ui.querySelector('[data-hero-video-playpause]');
    const iconPause = ui.querySelector('.hero__video-control-icon--pause');
    const iconPlay = ui.querySelector('.hero__video-control-icon--play');
    if (!btn || !iconPause || !iconPlay) return;
      btn.setAttribute('aria-pressed', paused ? 'false' : 'true');
      btn.setAttribute('aria-label', paused ? ui.dataset.labelPlay : ui.dataset.labelPause);
      iconPause.hidden = paused;
      iconPlay.hidden = !paused;
      }

      function bindUi(ui, root) {
      const key = ui.getAttribute('data-hero-video-ui');
      if (!key) return;
        const wrap = root.querySelector('[data-hero-video-root="' + key + '"]');
        if (!wrap) return;
          const video = wrap.querySelector('video');
          if (!video) return;

            const setFallback = function (active) {
            wrap.classList.toggle('hero__video-inner--fallback', Boolean(active));
            };

            const muteBtn = ui.querySelector('[data-hero-video-mute]');
            if (muteBtn) {
              muteBtn.addEventListener('click', function () {
              video.muted = !video.muted;
              root.querySelectorAll('[data-hero-video-ui="' + key + '"]').forEach(function (other) {
              syncMuteUi(other, video);
              });
              });
              }

              const ppBtn = ui.querySelector('[data-hero-video-playpause]');
              if (ppBtn) {
                ppBtn.addEventListener('click', function () {
                if (video.paused) {
                  video.play();
                  } else {
                  video.pause();
                  }
                  });
                  }

                  if (!video._heroVideoUiBound) {
                    video._heroVideoUiBound = true;
                    const syncKey = key;
                    const fallbackCheck = function () {
                    const hasRenderableFrame = video.readyState >= 2;
                    const playing = !video.paused && !video.ended;
                    setFallback(!(hasRenderableFrame && playing));
                    };

                    video.addEventListener('volumechange', function () {
                    root.querySelectorAll('[data-hero-video-ui="' + syncKey + '"]').forEach(function (other) {
                    syncMuteUi(other, video);
                    });
                    });
                    video.addEventListener('play', function () {
                    setFallback(false);
                    root.querySelectorAll('[data-hero-video-ui="' + syncKey + '"]').forEach(function (other) {
                    syncPlayUi(other, video);
                    });
                    });
                    video.addEventListener('playing', function () {
                    setFallback(false);
                    });
                    video.addEventListener('loadeddata', function () {
                    fallbackCheck();
                    });
                    video.addEventListener('pause', function () {
                    root.querySelectorAll('[data-hero-video-ui="' + syncKey + '"]').forEach(function (other) {
                    syncPlayUi(other, video);
                    });
                    });
                    ['error', 'stalled', 'suspend', 'abort', 'emptied', 'waiting'].forEach(function (evt) {
                    video.addEventListener(evt, function () {
                    setFallback(true);
                    });
                    });

                    // If autoplay is blocked or too slow, show fallback controls.
                    setTimeout(fallbackCheck, 2000);
                    }

                    syncMuteUi(ui, video);
                    syncPlayUi(ui, video);
                    }

                    function initHeroVideoBarBottomOffset(hero) {
                    if (!hero.classList.contains('hero--has-video')) return;

                      if (hero._heroBarOffsetCleanup) {
                        hero._heroBarOffsetCleanup();
                        hero._heroBarOffsetCleanup = null;
                        }

                        const content = hero.querySelector('.hero__content-wrapper');
                        if (!content) return;

                          let roGroup = null;
                          let mo = null;
                          const mql = window.matchMedia('(max-width: 749px)');

                          const apply = function () {
                          if (!mql.matches) {
                            hero.style.removeProperty('--hero-first-group-block-height');
                            return;
                            }
                            const firstGroup = content.querySelector('.group-block');
                            const h = firstGroup ? firstGroup.offsetHeight : 0;
                            hero.style.setProperty('--hero-first-group-block-height', h + 'px');
                            };

                            const bindGroupResizeObserver = function () {
                            if (roGroup) {
                              roGroup.disconnect();
                              roGroup = null;
                              }
                              const fg = content.querySelector('.group-block');
                              if (!fg) return;
                                roGroup = new ResizeObserver(apply);
                                roGroup.observe(fg);
                                };

                                apply();
                                bindGroupResizeObserver();

                                mo = new MutationObserver(function () {
                                bindGroupResizeObserver();
                                apply();
                                });
                                mo.observe(content, { childList: true, subtree: false });

                                const onViewportChange = function () {
                                apply();
                                };
                                window.addEventListener('resize', onViewportChange, { passive: true });
                                mql.addEventListener('change', onViewportChange);

                                hero._heroBarOffsetCleanup = function () {
                                if (roGroup) roGroup.disconnect();
                                  if (mo) mo.disconnect();
                                    window.removeEventListener('resize', onViewportChange);
                                    mql.removeEventListener('change', onViewportChange);
                                    hero.style.removeProperty('--hero-first-group-block-height');
                                    };
                                    }

                                    function initHeroVideo(root) {
                                    if (!root || !root.classList || !root.classList.contains('hero')) return;
                                      root.querySelectorAll('[data-hero-video-ui]').forEach(function (ui) {
                                      bindUi(ui, root);
                                      });
                                      initHeroVideoBarBottomOffset(root);
                                      }

                                      document.querySelectorAll('.hero').forEach(initHeroVideo);

                                      document.addEventListener('shopify:section:load', function (event) {
                                      const hero = event.target && event.target.querySelector && event.target.querySelector('.hero');
                                      if (hero) initHeroVideo(hero);
                                        });
                                        })();
                                        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({behavior: 'instant'});
      }
    }, {once: true});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-matching-selector"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const sections = document.querySelectorAll('[id^="ProductMatching-"]');

      sections.forEach((section) => {
        const option1 = section.querySelector('[data-product-matching-option-1]');
        const option2 = section.querySelector('[data-product-matching-option-2]');
        const option1Wrap = option1
          ? option1.closest('.product-matching-section__select-wrap')
          : null;
        const option2Wrap = option2
          ? option2.closest('.product-matching-section__select-wrap')
          : null;
        const button = section.querySelector('[data-product-matching-search]');
        const buttonLabel = button
          ? button.querySelector('.product-matching-section__button-label')
          : null;
        const results = section.querySelector('[data-product-matching-results]');
        const emptyState = section.querySelector('[data-product-matching-empty]');
        const sourceItems = section.querySelectorAll('[data-combination-source-item]');

        if (! option1 || ! option2 || ! button || ! results) return;
        


        let lastSearchedKey = '';
        const normalize = (value) => String(value || '').trim().toLowerCase();
        const getKey = () => `${
          normalize(option1.value)
        }::${
          normalize(option2.value)
        }`;
        const combinationMap = new Map();

        const hideAll = () => {
          if (emptyState) 
            emptyState.hidden = true;
          

        };

        const resetButtonLabel = () => {
          if (! buttonLabel) return;
          

          const defaultLabel = buttonLabel.getAttribute('data-default-label');
          if (defaultLabel) 
            buttonLabel.textContent = defaultLabel;
          

        };

        const setSuccessButtonLabel = () => {
          if (! buttonLabel) return;
          

          const successLabel = buttonLabel.getAttribute('data-success-label') || 'Find Another Result';
          buttonLabel.textContent = successLabel;
        };

        sourceItems.forEach((item) => {
          const combinationsRaw = item.getAttribute('data-combinations') || '';
          const collectionUrl = item.getAttribute('data-collection-url') || '';
          if (! collectionUrl || ! combinationsRaw) return;
          


          combinationsRaw.split('||').forEach((entry) => {
            const token = normalize(entry);
            if (token && ! combinationMap.has(token)) {
              combinationMap.set(token, collectionUrl);
            }
          });
        });

        const unlockSearch = () => {
          button.setAttribute('href', '#');
          button.setAttribute('aria-disabled', 'false');
          button.classList.remove('is-success');
          section.classList.remove('is-matched');
          if (option1Wrap) 
            option1Wrap.classList.remove('has-ping');
          

          if (option2Wrap) 
            option2Wrap.classList.remove('has-ping');
          

          resetButtonLabel();
        };

        option1.addEventListener('change', unlockSearch);
        option2.addEventListener('change', unlockSearch);

        button.addEventListener('click', (event) => {
          const key = getKey();
          if (button.getAttribute('aria-disabled') === 'true' && key === lastSearchedKey) {
            event.preventDefault();
            return;
          }

          event.preventDefault();
          button.setAttribute('aria-disabled', 'true');
          lastSearchedKey = key;
          results.classList.add('is-loading');

          window.setTimeout(() => {
            hideAll();
            const selectedKey = `${
              normalize(option1.value)
            }::${
              normalize(option2.value)
            }`;
            const matchedCollectionUrl = combinationMap.get(selectedKey);

            if (matchedCollectionUrl) {
              button.setAttribute('href', matchedCollectionUrl);
              button.setAttribute('aria-disabled', 'false');
              section.classList.add('is-matched');
              button.classList.add('is-success');
              if (option1Wrap) 
                option1Wrap.classList.add('has-ping');
              

              if (option2Wrap) 
                option2Wrap.classList.add('has-ping');
              

              setSuccessButtonLabel();

              window.location.href = matchedCollectionUrl;
            } else if (emptyState) {
              button.setAttribute('href', '#');
              button.setAttribute('aria-disabled', 'true');
              section.classList.remove('is-matched');
              button.classList.remove('is-success');
              if (option1Wrap) 
                option1Wrap.classList.remove('has-ping');
              

              if (option2Wrap) 
                option2Wrap.classList.remove('has-ping');
              

              resetButtonLabel();
              emptyState.hidden = false;
            }

            results.classList.remove('is-loading');
          }, 220);
        });
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
